import { render, staticRenderFns } from "./StrutturePresidiUtentiListComponent.vue?vue&type=template&id=7a881f55"
import script from "./StrutturePresidiUtentiListComponent.vue?vue&type=script&lang=js"
export * from "./StrutturePresidiUtentiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports